export default function About() {
  return (
    <section className="max-w-3xl mx-auto px-4 py-12 space-y-4">
      <h1 className="text-3xl font-semibold tracking-tight">Our Story</h1>
      <p className="text-foreground/80">
        Mano Glamping was created to share the slow, grounding beauty of Suan Pueng. Our tents blend
        the comfort of a boutique stay with the calm of nature.
      </p>
    </section>
  );
}
